<template>
  <div :idfwbonavigation="tabcouponnode.idfwbonavigation.toString()">
    <v-container fluid class="tab-coupon">
      <h3 class="coupon-name">{{ tabcouponnode.name }}</h3>

      <v-layout row class="tabs-wrapper clearfix" :class="{'tabs_home' : currentidfwbonavigation === 'top'}">
        <!--Tabs for current id fw bonavigation -->
        <v-flex xs12>
          <v-tabs fixed-tabs align-with-title v-if="currentidfwbonavigation === 'top'">
            <v-tab :class="['tab', {'active': tab.idfwbonavigation === selectedTab.idfwbonavigation},{'tabLive' : tab.idfwbonavigationtypes.includes('INPLAYPERSPORTTYPE')}]"
                  v-for="(tab, index) in tabs"
                  :key="index"
                  @click.stop="selectTab(tab.idfwbonavigation)"
                  :idfwbonavigation="tab.idfwbonavigation.toString()">{{ tab.name }}</v-tab>
          </v-tabs>
        </v-flex>
      <v-flex xs12 class="events_futures" v-if="!isRootSportsNavigation && tabs.length > 0">
          <div class="holder">
            <v-btn :ripple="false" :class="['tab','no-transition ', {'active': tab.idfwbonavigation === selectedTab.idfwbonavigation}]"
              v-for="(tab, index) in tabs"
              :key="index"
              @click.stop="selectTab(tab.idfwbonavigation)"
              :idfwbonavigation="tab.idfwbonavigation.toString()">
              {{ tab.name }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-tabs class="sports-filter small" v-if="showSportsFilter" xs12 fixed-tabs align-with-title  
          next-icon="chevron_right" 
          prev-icon="chevron_left" 
          show-arrows>
          <v-tab :class="['sport', 'tab', {'active': selectedSports.indexOf(sport) > -1}]"
            @click.stop="toggleSport(sport)"
            v-for="(sport, index) in availablePrematchSports" :key="index"><span :class="'pd-icon pd-icon-' + sport.split(' ').join('').toLowerCase()"></span>{{sport}}</v-tab>
      </v-tabs>

      <div class="tab-content" v-if="!isInPlayBoNode && selectedTab" :idfwbonavigation="selectedTab.idfwbonavigation.toString()">
        <div class="marketgroups" v-if="selectedTabMarketgroups && selectedTabMarketgroups.length > 0">
          <market-group v-for="(mg, index) in selectedTabMarketgroups"
                        :key="mg.idfwmarketgroup"
                        :idfwmarketgroup="mg.idfwmarketgroup"
                        :events-grouping="selectedTab.displaytemplatename"
                        :selected-sports="selectedSports"
                        :maxevents="selectedTab.maxitems || 0"
                        :all-sports-active="allSportsActive"
                        :show-marketgroup-name="false"
                        :counter="index"
                        :hideliveevents="selectedTab.overlay"></market-group>
        </div>
        <!--div v-if="!(selectedTabMarketgroups && selectedTabMarketgroups.length > 0)""> {{ $t('Sports.NoAvailableEvents') }}</div-->
      </div>

      <div v-if="isInPlayBoNode && selectedTab">
        <live-coupon :ontab="true" :idfosporttypescsv="selectedTab.csvparameters || 'ALL'" :maxeventspersporttype="selectedTab.maxitems" :couponname="selectedTab.name"></live-coupon>
      </div>
    </v-container>
  </div>

</template>
<script>
  import store from '@/store'
  import marketGroup from '@/components/sports/bettingoffer/marketGroup'
  import liveCoupon from '@/components/sports/bettingoffer/live/LiveCoupon'
  import Screen from '@/components/mixins/Screen'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'tab-coupon',

    props: [
      'tabcouponnode'
    ],
    mixins: [
      Screen,
      BettingOffer
    ],

    components: {
      marketGroup,
      liveCoupon
    },

    data () {
      return {
        selectedTabIdFwBoNavigation: -1,
        selectedSports: []
      }
    },

    computed: {
      tabs () {
        if (this.tabcouponnode && this.tabcouponnode.bonavigationnodes) {
          return this.tabcouponnode.bonavigationnodes.filter(item => this.checkIsNodeNavigationType(item, 'TAB') && ((item.hide && item.numactivefwmarketgroups > 0) || !item.hide))
        }

        return []
      },
      selectedTab () {
        return this.tabs.filter(item => item.idfwbonavigation === this.selectedTabIdFwBoNavigation)[0] || (this.tabs && this.tabs.length > 0 && this.tabs[0]) || undefined
      },
      selectedTabMarketgroups () {
        if (this.selectedTab && this.selectedTab.marketgroups) {
          return this.selectedTab.marketgroups
        } else {
          return []
        }
      },
      currentidfwbonavigation () {
        return this.idfwbonavigation2 || this.idfwbonavigation1 || 'top'
      },
      isInPlayBoNode () {
        return this.checkIsNodeNavigationType(this.selectedTab, 'INPLAYPERSPORTTYPE')
      },
      marketgroups () {
        return store.getters['marketgroupState/marketgroups']
      },
      availablePrematchSports () {
        if (!this.isInPlayBoNode) {
          var sports = []
          var self = this

          if (self.selectedTab && self.selectedTab.marketgroups) {
            self.selectedTab.marketgroups.forEach((mg) => {
              if (self.marketgroups[mg.idfwmarketgroup] && self.marketgroups[mg.idfwmarketgroup].events) {
                self.marketgroups[mg.idfwmarketgroup].events.forEach((event) => {
                  if (event.markets) {
                    var markets = event.markets
                    markets.forEach((market) => {
                      if (sports.indexOf(market.idfosporttype) === -1) {
                        sports.push(market.idfosporttype)
                      }
                    })
                  }
                })
              }
            })
          }
          return sports
        } else {
          return []
        }
      },
      isRootSportsNavigation () {
        return this.$route.name === 'sports'
      },
      showFilterBigger () {
        return !this.tabletAndBelow && this.isRootSportsNavigation && this.availablePrematchSports && this.availablePrematchSports.length > 1
      },
      showFilterSmaller () {
        return this.tabletAndBelow && this.isRootSportsNavigation && this.availablePrematchSports && this.availablePrematchSports.length > 1
      },
      showSportsFilter () {
        return this.isRootSportsNavigation && this.availablePrematchSports && this.availablePrematchSports.length > 1
      },
      allSportsActive () {
        return this.selectedSports.length === 0
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      }
    },

    methods: {
      selectTab (idfwbonavigation) {
        this.selectedTabIdFwBoNavigation = idfwbonavigation
      },
      toggleSport (sport) {
        if (this.selectedSports.indexOf(sport) === -1) {
          this.selectedSports.push(sport)
        } else {
          this.selectedSports.splice(this.selectedSports.indexOf(sport), 1)
        }
        this.checkIfAllSportsAreActive()
      },
      selectAllSports () {
        this.selectedSports = []
      },
      checkIfAllSportsAreActive () {
        if (this.selectedSports.length === this.availablePrematchSports.length || this.selectedSports.length === 0) {
          this.selectedSports = []
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config";
@import "~@/css/mixins";
@import "~@/css/sportIcons";

@media mobile-big-and-below
  //.tabs_home
  >>>.tabs__bar
    box-shadow: 0px -12px 12px #06283b
    background: none

.events_futures
  flex: 0 0 auto
  margin-left: auto

  @media mobile-big-and-below
    margin-left: 0
    width: 100%
    overflow-x auto

    .btn
      flex-grow: 1
      height: auto
      border-radius: 0
      margin: 0
      min-width auto
  .holder
    border: 1px solid #CFD6DB
    border-radius: 4px
    min-height: 36px
    margin: 8px 0 12px 0
    background-color: #fff

    @media mobile-big-and-below
      display: flex
      border-radius: 0
      height: auto
      min-height: 48px
      margin: 0 0 15px
      border: none

    @media mobile-big-and-below
      margin: 0 0 5px

  button
    border-radius: 3px
    height: 28px
    font-size: 14px
    font-weight: normal
    color: #445058 !important
    background: #fff !important
    margin: 3px
  @media mobile-big-and-below
    >>> .btn__content
      color: #0fb3a1 
      font-weight: normal
  .active
    background: #1493FF!important
    color: #fff !important
    >>> .btn__content
        color: #ffffff

    @media mobile-big-and-below
      background: #fff !important
      border-bottom: solid 2px #2396FC

      >>> .btn__content
        color: #fff
        font-weight: bold

.container
  .tab-coupons
    .container.tab-coupon
      padding-right: 24px
      @media mobile-big-and-below
        padding-right: 4px
        padding-left: 4px
        // background: #e5e8ed
      .coupon-name
        display: none
      .tabs-wrapper
        display: flex
        flex-wrap: wrap
        @media mobile-big-and-below
          expand(4px, horizontal)
        .tabs
          flex: 8
          @media mobile-big-and-below
            display:block
            flex: unset
        .sports-filter
          height: 56px
          background: #06283b
          padding-right: 10px
          white-space: nowrap
          z-index: 0
          flex: 0.5
          text-align: right
          display: flex
          align-items: center
          justify-content: flex-end
          @media mobile-big-and-below
            background: #fff
            flex: 1
            padding: 0 10px
            height: 60px
            justify-content: flex-start
          .label
            position: relative
            top: -15px
            font-size: 14px
            color: #fff
            text-transform: uppercase
            display: inline-block
            width: auto
          &.small
            flex 1
            justify-content flex-start
            .sport.tab.all-sports
              flex unset
              width 45px
              max-width 45px
        .sport.tab
          min-width 36px
          max-width 36px
          height: 36px
          margin: 5px
          border-radius: 20px
          border: 1px solid #06283b
          box-sizing: border-box
          padding: unset
          flex 1
          cursor: pointer
          background-position: center
          background-repeat: no-repeat
          background-color: #06283b
          background-size: 20px
          @media mobile-big-and-below
            background-color: white
            border: 1px solid #CFD6DB
            &.active
              border: 1px solid transparent
          &.all-sports
            color: white
            background: black
            font-size: 14px
            text-align: center
            padding-top: 6px
            width: 45px
            user-select: none
            flex 2
            max-width none
            @media mobile-big-and-below
              background-color: white
              border: 1px solid #CFD6DB
              color: #243359
              max-width 45px
            &.active
              background-color: #0D7FE1 !important
              border: 1px solid transparent
              @media mobile-big-and-below
                color: white
          &.active
            background-color: #0D7FE1 !important
            position: relative
            &:after
              position: absolute
              bottom: 2px
              right: 15px
              content:''
              width: 15px
              height: 15px
              display: block
              background-size: 15px 15px
              background-repeat: no-repeat


.browser-internet-explorer
  .application
    .tabs__container
      .sports-filter
        flex: 1.4 !important

.browser-firefox
  .application
    .tabs-wrapper
      .holder
        button
          min-width: 87px
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/tabCoupon.vue